import { FC } from 'react';
import {
  TransferOutcome,
  VsTransferEvent,
  useGetHeroConversationById,
} from '@vs-online-only-app/state';
import ConversationOutcomeCard, {
  ConversationOutcomeCardType,
} from './ConversationOutcomeCard';

type Props = {
  event: VsTransferEvent;
};

export const TransferOutcomeCard: FC<Props> = ({ event }) => {
  const { data: conversation } = useGetHeroConversationById(event.conversation);

  if (!conversation) {
    return null;
  }

  if (event.outcome === TransferOutcome.CANCELLED) {
    return (
      <ConversationOutcomeCard
        type={ConversationOutcomeCardType.TRANSFER_REQUEST}
        title={`${conversation.currentAgent.firstName} canceled this request.`}
        subtitle="This transfer request is no longer open."
      />
    );
  }
  if (event.outcome === TransferOutcome.ACCEPTED) {
    return (
      <ConversationOutcomeCard
        type={ConversationOutcomeCardType.TRANSFER_REQUEST}
        title={`${conversation.currentAgent.firstName} accepted this chat!`}
        subtitle="Keep an eye out for the next one."
      />
    );
  }
  if (event.outcome === TransferOutcome.EXPIRED) {
    return (
      <ConversationOutcomeCard
        type={ConversationOutcomeCardType.TRANSFER_REQUEST}
        title={'Transfer ended.'}
        subtitle="This transfer request was not accepted by anyone else."
      />
    );
  }

  return null;
};
